import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import CsvDownloader from 'react-csv-downloader';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import CallMadeIcon from '@material-ui/icons/CallMade';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Assignment from '@material-ui/icons/Assignment';
import AddToPhotos from "@material-ui/icons/AddToPhotos";
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import BackupIcon from '@material-ui/icons/Backup';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';
import SearchIcon from '@material-ui/icons/Search';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1, MaskDate, MaskCel, formateDate, validateDate, convertDate} from "beaktShared/helpers/masks";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApiFile } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

export default function ConciliacaoImportarArquivo() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, setValue, handleSubmit, errors, setError, clearError, getValues } = useForm({mode: "onChange"});
    const [loading,setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [list, setlist] = React.useState([]);
    const onSubmit = (data, e) => {        
        
        if (data.arquivo.length === 0) {
            showNotification("Selecione um arquivo para importação!", 'warning');
            return false;
        }

        setloading(true);
        
        var formData = new FormData();        
        formData.append("file", data.arquivo[0]);
        UsePostApiFile("ConciliacaoCartao/import/" + session.franquiaId,formData).then(result=>{
            setloading(false);  
            if(result.status !== 200 && result.status !== 201)
            {                       
                showNotification(result.message, 'danger');                
                return false; 
            } 
            console.log(result.data);
            setlist(result.data);
            setValue("arquivo", "");
            showNotification("Importação realizada com sucesso!", 'success');
            return true;                
        }); 
    }

    const columnsProp = [
    {
        Header: "Linha",
        accessor: "linha"
    },
    {
        Header: "Autorização",
        accessor: "dadosConciliacao.autorizacao"
    },
    {
        Header: "Sucesso",
        accessor: "sucessoImportacao",
        Cell : (props)=>{
            if (props.value == true)
                return <span>Sim</span>
            else
                return <span>Não</span>
        }
    },
    {
        Header: "Mensagem",
        accessor: "mensagem"        
    }]

    const columns = [...columnsProp]

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        { displayName: "DataAutorizacao", id: "DataAutorizacao" },
        { displayName: "Telefone", id: "Telefone" },
        { displayName: "Autorizacao", id: "Autorizacao" },
        { displayName: "CodCredenciamento", id: "CodCredenciamento" },
        { displayName: "Valor", id: "Valor" },
        { displayName: "Bandeira", id: "Bandeira" },
        { displayName: "Parcelas", id: "Parcelas" },            
        { displayName: "AutorizacaoUra", id: "AutorizacaoUra" },            
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];        
        setdataCSV(dtCsv);
    } 

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>                            
                <div>     
                    {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                    }      
                    {notification.show &&
                        <div><br/>
                        <SnackbarContent
                            message={notification.message}
                            color={notification.color}
                            closeNotification={() => setNotification({show:false})}
                            close
                        />
                    </div>}         
                    <GridContainer>                                                    
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="primary" icon>
                                    <CardIcon color="primary">
                                        <PlaylistAddCheckIcon />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>
                                    {t('conciliation.card_reconciliation_import')}
                                    </h4>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={8} md={8}>
                                            <FormControl fullWidth className={classes.formControl}>                               
                                                <TextField                                        
                                                    error={errors.arquivo?true:false}                                            
                                                    type="file"
                                                    label={t('label.file')+" *"}
                                                    variant="outlined"                                                                                    
                                                    inputRef={register({required: true})}
                                                    name="arquivo"
                                                    InputLabelProps={{shrink: true}}
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.arquivo && <span> {errors.arquivo.message}</span>}
                                                </FormHelperText>                                                                                                
                                                <CsvDownloader
                                                    filename="report"
                                                    columns={columnsCSV}
                                                    datas={dataCSV}
                                                    separator={";"}>
                                                    <Button round color="info" size="sm">Download Modelo</Button> 
                                                </CsvDownloader>
                                                <span>{t('conciliation.the_value_column_must_be_in_numeric_format')}</span>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={4} md={4}>
                                            <center>
                                            <Link to="./conciliacaocartao" >
                                                <Button round className={classes.updateProfileButton}>
                                                {t('label.return')}
                                                </Button>
                                            </Link>                                            
                                            <Button round type="submit" color="primary">
                                            {t('label.import')}
                                                {loading && <div>...{t('label.loading')}</div>}
                                            </Button>
                                            </center>
                                        </GridItem>
                                    </GridContainer>
                                    {list.length > 0 &&
                                        <GridContainer>                                        
                                            <GridItem xs={12} sm={12} md={12}>
                                                <div className="subTitulo" style={{marginTop:'20px'}}> 
                                                    <h6>{t('conciliation.result_import')}</h6>
                                                </div>
                                                <ReactTable
                                                    loading = {loading}
                                                    data={list}
                                                    filterable
                                                    defaultFilterMethod = {noCaseSensitive}
                                                    columns={columns}
                                                    defaultPageSize={10}
                                                    minRows={5}
                                                    showPaginationBottom={true}
                                                    className="-striped -highlight"
                                                    previousText={t('button.previous')}
                                                    nextText={t('button.next')}
                                                    loadingText={t('label.loading')+"..."}
                                                    noDataText={t('information_message.no_records_found')+"!"}
                                                    pageText={t('label.page')}
                                                    ofText={t('label.of')}
                                                    rowsText={t('label.rows')}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    }
                                </CardBody>  
                            </Card>
                        </GridItem>
                    </GridContainer>                
                </div>
            </form>
        </div>
    );
}